import Swiper from "swiper/bundle";

export default new class CategoryProductSlider {
    constructor() {
        this.categorySliderContainer = 'category-slider__container';

        this.handler();
    }

    handler() {
        document.addEventListener('DOMContentLoaded', () => {
            this.init();
        });
    }

    init(){
        new Swiper(`.${this.categorySliderContainer}`, {
            slidesPerView: 1,
            watchOverflow: true,
            autoplay: true,
            speed: 2000,
            navigation: {
                nextEl: ".category-slider-next",
                prevEl: ".category-slider-prev",
            },
        });
    }
}();
